import {HelpService} from './../../help/help.service';
import {Title} from '@angular/platform-browser';
import {Component, OnInit, QueryList, ViewChild, ViewChildren, inject} from '@angular/core';

import {UtilsService} from 'src/app/services/utils.service';
import {AppDevNotifyComponent} from 'src/app/widgets/dev-notify-bar/dev-notify-bar.component';
import {TaskDataFilter, ValidFilters} from '../../stock/stock.service';
import {FcvalidationlogService} from '../fcvalidationlog.service';
import {ShareDataService} from 'src/app/services/share-data.service';
import {ExportFilter, FilterInput, FilterMappingService} from 'src/app/models/filter-objects';
import {ActivatedRoute, Data} from '@angular/router';
import {TaskService} from '../../task/task.service';
import {BookmarkData} from 'src/app/models/Bookmark';
import {FileExportService} from 'src/app/common/file-export-service';
import { ScrollService } from 'src/app/services/scroll.service';
import { SettingsService } from '../../settings/settings.service';
import { DxPopoverComponent } from 'devextreme-angular';
import { firstValueFrom } from 'rxjs';
import { BaseSelectStatementId } from 'src/app/enums/base-select-statement-id.enum';
import { SelectionSetId } from 'src/app/enums/selection-set-id.enum';
import { SelectStatementOptions } from 'src/app/models/select-statement-options.model';
import { BookmarkNewComponent } from 'src/app/widgets/bookmark-new/bookmark-new.component';
import { BookmarkElementsOperator } from 'src/app/widgets/bookmark-new/operators/elements-operators/bookmark-elements.operator';
import { FiltersGroupBookmarkElementsOperator } from 'src/app/widgets/bookmark-new/operators/elements-operators/filters-group-bookmark-elements.operator';
import { FiltersOperator } from 'src/app/widgets/filters/api/filters-operator.api';

@Component({
    selector: 'app-validationlog',
    templateUrl: './validationlog.component.html',
    styleUrls: ['./validationlog.component.scss'],
    standalone: false
})
export class ValidationlogComponent implements OnInit {

	captionAction = 'Client Response';
	action = 'Filter';
	pageName: string = 'ForecastValidationLog';

	//Filter Variable initialization
	Valid: any = [];
	PageSize = 51;
	PageNo = 1;

	StopScrolling = false;
	scrollByContent = true;
	scrollByThumb = true;
	//default data initialization
	fcvalidationitemdata: any = [];
	GraphHeight: any = '';
	GraphWidth: any = '';
	SalesGraphType: any = '';
	ForecastingGraphType: any = '';

	ValdationCommentObject: string[];

	private _scrollService: ScrollService = inject(ScrollService);
	@ViewChildren(DxPopoverComponent) popovers: QueryList<DxPopoverComponent>;
	
	public onScrolledDown() {
		if (!this.IsInfinitScrollDisabled) {
			this.PageNo += 1;
			this.getForecastValdata('reload');
		}
	}

	//Filters
	public pageFiltersOperator: FiltersOperator = new FiltersOperator(
		new SelectStatementOptions(
		  {
			filters: async () => this.pageFiltersOperator.appliedFilters,
	
			baseSelectStatementId: BaseSelectStatementId.DEV_GetForecastValidationLogFilters,
			selectionSetId: SelectionSetId.ForecastingValidtionLogFilter,
		  }
		)
	);
	//Bookmark
	@ViewChild('bookmarksGroup', { static: false })
	public bookmarksGroup: BookmarkNewComponent;
	  
	private _activatedRoute: ActivatedRoute = inject(ActivatedRoute);
	public bookmarkElementsOperators: BookmarkElementsOperator[];
	
	public async initializeBookmarks(): Promise<Data> {
	let routeData: Data = await firstValueFrom(this._activatedRoute.data);
	
	this.bookmarkElementsOperators = [
		new FiltersGroupBookmarkElementsOperator(
		  {
			id: UtilsService.computeRouteHash(routeData.id, FiltersGroupBookmarkElementsOperator.DEFAULT_ID_PART).toString(),
			filtersOperator: () => this.pageFiltersOperator
		  }
		)
	];
	
	return routeData;
	}

	constructor(
		private fcvaldataservice: FcvalidationlogService,
		private titleService: Title,
		private helpService: HelpService,
		private shareDataService: ShareDataService,
		private route: ActivatedRoute,
		private taskService: TaskService,
		private fileExportService: FileExportService,

		private _settingsService: SettingsService,
	) {
		this.shareDataService.CleanData();
	}

	taskFilterData: TaskDataFilter[];
	IsTaskLoad = false;

	public gridNumberOfColumns: number = 0;

	async ngOnInit() {
		this.titleService.setTitle('Validation Log');

		this._settingsService.getCoreSetting(
			null,
			'ValidationLogNumberOfColumns',
			undefined,
			{
				showLoadingIndicator: true,
			}
		).then(
			(response) => {
				this.gridNumberOfColumns = Number.parseInt(response.value);
			}
		);

		this._scrollService.scrolledDownObservable.subscribe(
			{
				next: () => {
					this.onScrolledDown();
				}
			}
		);

		this.route.paramMap.subscribe((params) => {
			const value = this.route.snapshot.queryParamMap.get('taskid');
			if (value) {
				this.taskService.SelectTaskFilterValues(value).subscribe(
					(data) => {
						this.taskFilterData = data;
						this.taskFilterData.forEach(
							(_) => {
			  
							}
						  );
						  this.pageFiltersOperator.load(
							{
							  showLoadingIndicator: true,
							}
						  );
						this.loadPageData();
						this.getForecastValdata('filterData');
					},
					(err) => {}
				);
			}
		});
		this.GetSettingsData();
		this.GetCaption();

	    await this.initializeBookmarks();
    	this.loadPageData();
    	this.pageFiltersOperator.onFiltersApplied.subscribe(
      	 (selection) => {
			this.IsInfinitScrollDisabled = true;
			this.PageSize = 51;
			this.PageNo = 1;
			this.StopScrolling = false;
         	this.shareDataService.CleanData();
         	this.shareDataService.filterOptionOverview = selection.output;
         	this.pageFiltersOperator.load(
         	  {
         	    showLoadingIndicator: true,
         	  }
         	);
            this.getForecastValdata('Colmn');

         	this.ExportToExcelFilters = this.filterMappingService.mapQueryFilterOutputToFilterValue(this.shareDataService.filterOptionOverview.filters);
      	 }
    	);
	}

	public async loadPageData() {
		(await this.pageFiltersOperator.getObservable(
			{
				showLoadingIndicator: true,
			}
		)).subscribe(
			{
				next: async (_) => {
					if (!(await this.bookmarksGroup.applyDefaultBookmark())) {
						this.getForecastValdata('Colmn');
					}
				}
			}
		);
	}

	GetCaption() {
		this.fcvaldataservice.getCaptionbyAction('ForecastClientCaption').subscribe((data) => {
			if (data != null && data.find((x) => x.name == 'ClientResponse') != null && data.find((x) => x.name == 'ClientResponse').value != null) {
				this.captionAction = data.find((x) => x.name == 'ClientResponse').value;
			}
		});
	}

	private getForecastValdata(action) {
		if (this.StopScrolling) {
			AppDevNotifyComponent.SuccesMessage('You have reach end of search. ');
		}  else {
			if (action !== 'reload') {
				if (this.Valid?.DynamicCols && this.Valid.DynamicCols.length > 0) {
					action = 'filterData';
				} else {
					action = 'Colmn';
				}
			}
			this.fcvaldataservice.getForecastvaldataNew(action, this.PageNo, this.PageSize, this.pageFiltersOperator.overviewFiltersOutput.filters).subscribe(
				(data) => {
					if (action == 'filterData') {
						this.Valid.ValidLogData = [];
					}

					if (action == 'Colmn') {
						//Main data with all group and grapgh data
						this.Valid.ValidLogData = data.fcValDatalst;

						//Graph Height and Width for sales and forecast
						this.Valid.DynamicCols = data.fcValItemDatalst.filter((x) => x.selectGroup == 'Forecasting Validation Log List');
						this.Valid.DynamicColsHerder = data.fcValItemDatalst.filter((x) => x.selectGroup == 'Forecasting Validation Header');

						if (data.fcValGrphDatalst != null && data.fcValGrphDatalst.length > 0) {
							for (let k = 0; k < data.fcValGrphDatalst.length; k++) {
								if (data.fcValGrphDatalst[k].name != null && data.fcValGrphDatalst[k].name == 'ValidationLogGraphHeight') {
									this.GraphHeight = data.fcValGrphDatalst[k].value;
								}
								if (data.fcValGrphDatalst[k].name != null && data.fcValGrphDatalst[k].name == 'ValidationLogGraphWidth') {
									this.GraphWidth = data.fcValGrphDatalst[k].value;
								}
							}
						}

						//Graph type for sales and forecast
						if (data.fcValGrphlst != null && data.fcValGrphlst.length > 0) {
							for (let l = 0; l < data.fcValGrphlst.length; l++) {
								if (data.fcValGrphlst[l].value != '-1') {
									if (data.fcValGrphlst[l].name != null && data.fcValGrphlst[l].name == 'SalesGraphType') {
										this.SalesGraphType = data.fcValGrphlst[l].value;
									}
									if (data.fcValGrphlst[l].name != null && data.fcValGrphlst[l].name == 'ForecastingGraphType') {
										this.ForecastingGraphType = data.fcValGrphlst[l].value;
									}
								}
							}
						}
					} else {
						Object.keys(data.fcValDatalst).forEach((key) => {
							let DataExists = this.Valid.ValidLogData.filter((x) => x == data.fcValDatalst[key]);
							if (DataExists == null || DataExists.length == 0) {
								this.Valid.ValidLogData.push(data.fcValDatalst[key]);
							}
						});
					}

					//getting data to barData to genrate graph forcast and sales
					for (let i = 0; i < this.Valid.ValidLogData.length; i++) {
						this.Valid.ValidLogData[i].barData = this.customizedataforgraph(this.Valid.ValidLogData[i]);

						let title = '';
						for (let index = 0; index < this.Valid.DynamicColsHerder.length; index++) {
							title += this.Valid.ValidLogData[i][this.Valid.DynamicColsHerder[index].dataField] + ' ';
						}
						this.Valid.ValidLogData[i].HeaderTitle = title;

						this.Valid.ValidLogData[i].CommentAccept = '';
						this.Valid.ValidLogData[i].CommentReject = '';

						if (this.Valid.ValidLogData[i].ExtClientcomment != null && this.Valid.ValidLogData[i].ExtClientcomment != undefined) {
							if (this.Valid.ValidLogData[i].ExtClientResponse == 'Accept') {
								this.Valid.ValidLogData[i].CommentAccept = this.Valid.ValidLogData[i].ExtClientcomment;
							} else {
								this.Valid.ValidLogData[i].CommentReject = this.Valid.ValidLogData[i].ExtClientcomment;
							}
						}
					}

					this.IsInfinitScrollDisabled = false;
					if (Object.keys(data.fcValDatalst).length != this.PageSize) {
						this.StopScrolling = true;
					}
				},

				(err) => {
					console.log(err);
				}
			);
		}
	}

	private customizedataforgraph(itemarr) {
		let data: any = [];
		data.push({sales: 'Actual-12', value: itemarr.Actual12});
		data.push({sales: 'Actual-11', value: itemarr.Actual11});
		data.push({sales: 'Actual-10', value: itemarr.Actual10});
		data.push({sales: 'Actual-9', value: itemarr.Actual9});
		data.push({sales: 'Actual-8', value: itemarr.Actual8});
		data.push({sales: 'Actual-7', value: itemarr.Actual7});
		data.push({sales: 'Actual-6', value: itemarr.Actual6});
		data.push({sales: 'Actual-5', value: itemarr.Actual5});
		data.push({sales: 'Actual-4', value: itemarr.Actual4});
		data.push({sales: 'Actual-3', value: itemarr.Actual3});
		data.push({sales: 'Actual-2', value: itemarr.Actual2});
		data.push({sales: 'Actual-1', value: itemarr.Actual1});

		data.push({fcdata: 'Forecast+1', value1: itemarr.Forecast1});
		data.push({fcdata: 'Forecast+2', value1: itemarr.Forecast2});
		data.push({fcdata: 'Forecast+3', value1: itemarr.Forecast3});
		data.push({fcdata: 'Forecast+4', value1: itemarr.Forecast4});
		data.push({fcdata: 'Forecast+5', value1: itemarr.Forecast5});
		data.push({fcdata: 'Forecast+6', value1: itemarr.Forecast6});
		data.push({fcdata: 'Forecast+7', value1: itemarr.Forecast7});
		data.push({fcdata: 'Forecast+8', value1: itemarr.Forecast8});
		data.push({fcdata: 'Forecast+9', value1: itemarr.Forecast9});
		data.push({fcdata: 'Forecast+10', value1: itemarr.Forecast10});
		data.push({fcdata: 'Forecast+11', value1: itemarr.Forecast11});
		data.push({fcdata: 'Forecast+12', value1: itemarr.Forecast12});
		return data;
	}

	UpdateClientResponse(action, item) {
		let Data = {forecastobjid: 0, comment: '', issue: ''};
		Data.forecastobjid = item.ForecastObjectId;
		if (action == 'Accept') {
			Data.comment = item.CommentAccept;
			item.CommentReject = '';
		} else if (action == 'Reject') {
			Data.comment = item.CommentReject;
			item.CommentAccept = '';
		} else {
			Data.comment = '';
			item.CommentReject = '';
			item.CommentAccept = '';
		}
		Data.issue = action;

		this.fcvaldataservice.updateclientresponse(Data).subscribe((resp) => {
			if (resp && resp.msg) {
				AppDevNotifyComponent.SuccesMessage(resp.msg);
				let index = this.Valid.ValidLogData.indexOf(item);
				item.ExtClientResponse = resp.clientresponse;
				if (index != null && index > -1) {
					this.Valid.ValidLogData[index] = item;
				}
			} else {
				AppDevNotifyComponent.ErrorMessage('Last validation id not found for given item.');
			}
		});
	}

	IsInfinitScrollDisabled: boolean = false;

	OpenDeepDive(item) {
		window.open('forecast/deep-dive?id=' + UtilsService.getURLHelper(item.pageid), '_blank');
	}

	currentlySelectedFilters: FilterInput[] = [];
	dataFilter: BookmarkData;

	proceedingInfoPopup = false;
	actionValid = '';
	AcceptRejectAll(action) {
		this.proceedingInfoPopup = true;
		this.actionValid = action;
	}

	updateAllItemStatus() {
		let Items = new ValidFilters();
		Items.action = this.actionValid;
		Items.filters = this.pageFiltersOperator.overviewFiltersOutput.filters;
	
		this.fcvaldataservice.UpdateValidationFilters(Items).subscribe(
			(res) => {
				this.proceedingInfoPopup = false;
				if (res.flag > 0) {
					this.pageFiltersOperator.applyFilters();
					AppDevNotifyComponent.SuccesMessage(res.msg);
				} else {
					AppDevNotifyComponent.ErrorMessage(res.msg);
				}
			},
			(err) => {
				console.log(err);
			}
		);
	}

	/* Export Forecast Option */

	IsExportEnable = false;
	GetSettingsData() {
		this.fileExportService.WebSettings('EnableExportForecastValidationLog').subscribe(
			(resultFilename) => {
				this.IsExportEnable = resultFilename.value.toLowerCase() == 'yes' ? true : false;
			},
			(err) => {
				console.log(err);
			}
		);
	}
	filterMappingService = new FilterMappingService();
	ExportToExcelFilters: ExportFilter[] = [];
	// Method to receive value from child
	receiveExportToExcelFilters(value: ExportFilter[]) {
		this.ExportToExcelFilters = value;
	}

	hidePopoverById(targetId: string) {
		const popover = this.popovers.find(p => p.instance.option('target') === `#${targetId}`);
		if (popover) {
		  popover.instance.hide();
		}
	  }
}
